<footer>
  <div class="footer-container">
    <div class="footer-copyright">&copy; 2026 Jakub Wegielewski</div>
    <ul class="footer-nav">
      <li><a routerLink="/portfolio">Portfolio</a></li>
      <li><a href="#about">About</a></li>
      <li><a href="/assets/privacy_policy.html">Privacy policy</a></li>
      <li><a href="mailto:jawegielewski@gmail.com">Contact</a></li>

      <!-- 🛠️ This acts as our invisible switcher element -->
      <div class="line-break"></div>

      <li>
        <a target="_blank" href="https://www.linkedin.com/in/jakub-wegielewski">
          <img alt="LinkedIn" src="assets/images/linkedin.png" title="LinkedIn" width="32" height="32">
        </a>
      </li>
      <li>
        <a target="_blank" href="https://play.google.com/store/apps/dev?id=6173561253714763017">
          <img alt="Google Play" src="assets/images/google_play.png" title="Google Play" width="32" height="32">
        </a>
      </li>
      <li>
        <a target="_blank" href="https://github.com/jawegielewski">
          <img alt="GitHub" src="assets/images/github.png" title="GitHub" width="32" height="32">
        </a>
      </li>
      <li>
        <a target="_blank" href="https://www.facebook.com/profile.php?id=61566097928671">
          <img alt="Facebook" src="assets/images/facebook.png" title="Facebook" width="32" height="32">
        </a>
      </li>
    </ul>
  </div>
</footer>
